import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';  
import { environment } from "src/environments/environment";
import { Socket } from "ngx-socket-io";

@Injectable({
  providedIn: 'root'
})
export class SocketService {

  constructor(private socket : Socket) {
    // The Socket instance is injected and should not be reassigned.
    // Ensure that ngx-socket-io is configured with the correct URL in your AppModule.
  }

  public connect() {
    // this.socket = io(`${environment.apiUrl}chat`);
    // console.log(this.socket);
  }

  public listen(eventName: string) {
    return new Observable((subscriber) => {
      this.socket.on(eventName, (data) => {
        subscriber.next(data);
      })
    })
  }
  public emit(eventName: string, data: any) { 
    this.socket.emit(eventName, data);
  }
}
